import { faOctagonExclamation, faRotateExclamation, faTriangleExclamation, faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import VoxelChip from '../../../../components/voxel/Chips/VoxelChip';
import { GoogleAdsParsingStatusGq } from '../../../../graphql/projects/models/GoogleAdsParsingStatusGq';
import { GoogleAdsRequestAnalysisGq } from '../../../../graphql/projects/models/GoogleAdsRequestAnalysisGq';

export interface ProjectStatusKeywordRequestIconProps {
  requestAnalysis: GoogleAdsRequestAnalysisGq;
  hideCompleted?: boolean;
}

const ProjectStatusKeywordRequestIcon: React.FC<ProjectStatusKeywordRequestIconProps> = ({
  requestAnalysis,
  hideCompleted,
}) => {
  const countLeft = requestAnalysis.processingCalls + requestAnalysis.queuedCalls;
  const countTotal = requestAnalysis.processingCalls + requestAnalysis.totalCalls;
  const counter = `${countTotal - countLeft}/${countTotal}`;
  if (requestAnalysis.request.paused) {
    return (
      <VoxelChip size="xs" color="info" title={counter} />
    );
  }

  // Pre processing scenarios
  if (
    requestAnalysis.request.parsingStatus === GoogleAdsParsingStatusGq.PROCESSING ||
    requestAnalysis.comboTagsSettingUp ||
    requestAnalysis.comboSettingUp
  ) {
    return (
      <VoxelChip size="xs" color="info" title={counter} />
    );
  }

  if (requestAnalysis.request.parsingStatus === GoogleAdsParsingStatusGq.FAILED) {
    return (
      <FontAwesomeIcon icon={faOctagonExclamation} className="text-error-600/70" />
    );
  }

  // Google suggest scenarios
  if (
    !!requestAnalysis.suggestSeedsCronJobFailed &&
    requestAnalysis.suggestSeedsCronJobFailed + requestAnalysis.suggestSeedsCompleted ==
    requestAnalysis.suggestSeedsTotal
  ) {
    return (
      <FontAwesomeIcon icon={faOctagonExclamation} className="text-error-600/70" />
    );
  }

  if (
    !!requestAnalysis.suggestSeedsPubSubPossibleFail &&
    requestAnalysis.suggestSeedsCronJobFailed + requestAnalysis.suggestSeedsCompleted <
    requestAnalysis.suggestSeedsTotal
  ) {
    return (
      <FontAwesomeIcon icon={faRotateExclamation} className="text-warning-600/70" />
    );
  }

  if (
    requestAnalysis.suggestSeedsCompleted < requestAnalysis.suggestSeedsTotal ||
    requestAnalysis.suggestKeywordsBatching
  ) {
    return (
      <VoxelChip size="xs" color="info" title={counter} />
    );
  }

  // Completed scenarios
  if (requestAnalysis.completedCalls === requestAnalysis.totalCalls) {
    if (hideCompleted) return null;
    return (
      <FontAwesomeIcon icon={faCheckCircle} className='text-success-600/70' />
    );
  }

  if (
    requestAnalysis.completedCalls > 0 &&
    requestAnalysis.completedCalls + requestAnalysis.failedCalls === requestAnalysis.totalCalls
  ) {
    return (
      <FontAwesomeIcon icon={faTriangleExclamation} className="text-warning-600/70" />
    );
  }

  if (requestAnalysis.failedCalls === requestAnalysis.totalCalls) {
    return (
      <FontAwesomeIcon icon={faOctagonExclamation} className="text-error-600/70" />
    );
  }

  if (requestAnalysis.processingCalls || requestAnalysis.queuedCalls) {
    return (
      <VoxelChip size="xs" color="info" title={counter} />
    );
  }

  return <>-</>;
};

export default ProjectStatusKeywordRequestIcon;
